import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class LinhaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let linha = model;
        
        if (isNull(linha.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(linha.grupoproduto) || isNull(linha.grupoproduto.idgrupoproduto)){
            refs.gpSelect.focusedOut = true;
            validated = false;
        }
        if (isNull(linha.subgrupoproduto) || isNull(linha.subgrupoproduto.idsubgrupoproduto)){
            refs.subgrupoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(linha.idlinhaprodutoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }

}